import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAnglesRight, faAnglesLeft } from '@fortawesome/free-solid-svg-icons'
import { setSidebarIsActive } from "../redux/layoutSlice"
import HistoryDrawer from '../pages/modals/HistoryDrawer'
import CalloutBanner from './elements/CalloutBanner'
import BannerTag from './elements/BannerTag'
import Loading from "./Loading";
import DuplicateBanner from "./elements/DuplicateBanner";

export default function LayoutSidebar(props) {
  const {
    id,
    actionButtons,
    contentTitle,
    banners = null,
    content,
    dashlets,
    customLayoutedActionButtons,
    isLoadingBanners = false,
    portfolioLabel = null,
  } = props;

  const dispatch = useDispatch()
  const layout = useSelector((state) => state.layout)

  useEffect(() => {
    if (!dashlets) {
      dispatch(setSidebarIsActive({ sidebarIsActive: false }))
    }
  }, [dashlets])

  const toggleSidebar = () => dispatch(setSidebarIsActive({ sidebarIsActive: !layout.sidebarIsActive }))

  return (
    <>
      <section
        data-testid="layout-sidebar-header"
        className={`lox-layout-sidebar__header lox-has-border-bottom has-background-light ${customLayoutedActionButtons && 'has-customized-header'}`}
      >
        <div className="container is-fluid my-3">
          <div className="columns" style={{ overflow: 'visible' }}>
            <div className={`column ${layout.sidebarIsActive && 'is-three-quarters'} pl-1`}>
              <div className="columns" style={{ overflow: 'visible' }}>
                <div className="column is-flex is-flex-direction-column is-justify-content-center is-align-items-flex-start" style={{ flexGrow: '0' }}>
                  {id && (
                    <p data-testid="layout-sidebar-id" className="lox-layout-sidebar__header__id has-text-grey is-size-7">
                      ID#
                      {id}
                    </p>
                  )}
                  <div data-testid="layout-sidebar-title" className="title has-text-primary is-flex" style={{ whiteSpace: 'nowrap', marginBottom: '2px' }}>
                    {contentTitle}
                  </div>
                  {portfolioLabel ? (
                    <p data-testid="layout-sidebar-portfolio" className="lox-layout-sidebar__footer__portfolio has-text-grey is-size-7">
                      {portfolioLabel}
                    </p>
                  ) : null}
                </div>
                {(isLoadingBanners || banners) && (
                  <div className="column is-flex is-flex-direction-column is-justify-content-center is-align-items-flex-start">
                    <div className="columns" style={{ overflow: "visible" }}>
                      {banners?.banner_tags && <BannerTag bannerTags={banners.banner_tags} />}
                      {banners?.callout_banners && <CalloutBanner calloutBanners={banners.callout_banners} />}
                      {banners?.duplicate_banners && <DuplicateBanner duplicateBanners={banners.duplicate_banners} />}
                      {isLoadingBanners && <Loading />}
                    </div>
                  </div>
                )}
                <div className="column is-flex is-flex-direction-column is-justify-content-space-between is-align-items-flex-end p-0">
                  {!customLayoutedActionButtons && (
                    <div data-testid="layout-sidebar-action-buttons" className="lox-layout-sidebar__header__action-buttons is-flex is-flex-direction-row is-multiline header-button-container">
                      {actionButtons}
                      {dashlets && false && (
                        // <div className="columns">
                        <button
                          type="button"
                          className="button is-gray is-small mx-1"
                          onClick={toggleSidebar}
                        >
                          <span className="icon is-small">
                            {!layout.sidebarIsActive ? (
                              <FontAwesomeIcon icon={faAnglesLeft} />
                            ) : (
                              <FontAwesomeIcon icon={faAnglesRight} />
                            )}
                          </span>
                        </button>
                        // </div>
                      )}
                    </div>
                  )}
                  {customLayoutedActionButtons && customLayoutedActionButtons}
                </div>
              </div>
            </div>
            <div
              className={`column is-one-quarters is-flex is-flex-direction-column is-justify-content-center is-align-items-flex-start ${!layout.sidebarIsActive && 'is-hidden'
                }`}
            >
              <p className="title has-text-primary">
                <span className="title has-text-primary">Dashlets</span>
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="lox-layout-sidebar__content pt-3 is-relative">
        <HistoryDrawer />
        <div className={`container is-fluid ${layout.sidebarIsActive ? 'pr-0' : 'pr-3'}`}>
          <div className="columns">
            <div
              className={`lox-layout-sidebar__content__main column ${layout.sidebarIsActive && 'is-three-quarters'
                } px-0 py-0`}
            >
              <div id="main_content" data-testid="layout-sidebar-content" className={`lox-layout-sidebar__content__main__wrapper pr-2 ${customLayoutedActionButtons && 'has-customized-header'}`}>
                {content}
              </div>
            </div>
            {layout.sidebarIsActive && (
              <div className="divider is-vertical is-hidden-mobile" />
            )}
            <div
              className={`lox-layout-sidebar__content__sidebar column ${!layout.sidebarIsActive && 'is-hidden'
                } is-one-quarters p-0 py-0`}
            >
              <div data-testid="layout-sidebar-dashlets" className="lox-layout-sidebar__content__sidebar__wrapper mr-3">
                {dashlets && dashlets}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
